type Row = {
  id: string;
  fromWeight: number;
  product: { id: string; label: string };
};

export const checkStartWeight = (rows: Row[]): boolean => {
  return rows.some((row, idx) => idx === 0 && row.fromWeight !== 0);
};

export const checkDuplicateProfiles = (rows: Row[]): boolean => {
  let lines = rows.map((item) => item.fromWeight);
  return lines.some((item, idx) => lines.indexOf(item) != idx);
};
